import getProductPrice from '../helpers/getProductPrice';
import productModel from './productModel';


const removeFromCartModel = function googleAnalyticsremoveFromCart(
  product,
  quantity,
  eventCallback,
) {
  return {
    event: 'remove_from_cart',
    ecommerce: {
      currency: 'USD',
      value: getProductPrice(product),
      items: [
        { ...productModel(product, { quantity }) },
      ],
    },
    eventCallback,
  };
};

export default removeFromCartModel;
